import { Text } from 'bold-ui'
import { useAlergiasCardQuery } from 'graphql/hooks.generated'
import { GrauCertezaAlergia } from 'graphql/types.generated'
import React from 'react'

import { AlergiaReacaoModel } from '../../avaliacao/components/alergias-reacoes/model'
import { AccordionCardSection } from '../components/AccordionCardSection'
import { ContentCardSection } from '../components/ContentCardSection'
import { AlergiasListCard } from './AlergiasListCard'
import formatAlergias from './formatAlergias'

export interface AlergiasCardProps {
  prontuarioId: ID
  alergiasAvaliadas: AlergiaReacaoModel[]
}

export function AlergiasCard(props: AlergiasCardProps) {
  const { prontuarioId, alergiasAvaliadas } = props

  const { data, loading } = useAlergiasCardQuery({
    variables: {
      filtro: {
        prontuarioId,
        grausCerteza: [GrauCertezaAlergia.CONFIRMADO, GrauCertezaAlergia.SUSPEITO, GrauCertezaAlergia.NAO_INFORMADO],
      },
      prontuarioId: prontuarioId,
    },
  })

  const todasAlergias = formatAlergias(data?.alergias?.content || [], alergiasAvaliadas)
  const alergiasExpandido = todasAlergias.getAlergiasExpandido()
  const alergiasAccordion = todasAlergias.getAlergiasAccordion()
  const existeAlergiaResolvida = data?.existemAlergiasResolvidasRefutadas

  return (
    <>
      <ContentCardSection isLoading={loading} messageLoading='Carregando dados das alergias'>
        <AlergiasListCard alergias={alergiasExpandido} />
        {alergiasExpandido.length === 0 &&
          (existeAlergiaResolvida ? (
            <Text component='p'>Ver alergias resolvidas ou refutadas.</Text>
          ) : (
            <Text component='p'>Nenhuma alergia ou reação adversa registrada.</Text>
          ))}
      </ContentCardSection>

      {alergiasAccordion.length > 0 && (
        <AccordionCardSection
          id='AlergiasCard'
          title={{
            closed: `Mostrar + ${alergiasAccordion.length} alergias`,
            open: `Esconder alergias`,
          }}
          expanded
        >
          <AlergiasListCard alergias={alergiasAccordion} />
        </AccordionCardSection>
      )}
    </>
  )
}
